import styles from "pages/replacements-page-styles.module.css";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import ShoppingCartItemsLengthIcon from "components/Replacements/ShoppingCartItemsLengthIcon.tsx";
import { StyledShoppingCartOutlinedIcon } from "components/Replacements/ShoppingCartHeader.styles.ts";
import { getAllItemsCount } from "components/Replacements/ReplacementsUtil.ts";
import FlyoutHandler from "components/Replacements/FlyoutHandler.tsx";

interface ShoppingCartIconProps {
	showButtons: boolean;
}

const ShoppingCartIcon = ({ showButtons }: ShoppingCartIconProps) => {
	const [showReplacement, setShowReplacement] = useState(false);
	const [showShoppingCart, setShowShoppingCart] = useState(false);

	const toggleShoppingCart = () => setShowShoppingCart(true);

	useEffect(() => {
		if (showReplacement) {
			setShowReplacement(false);
		}
		if (showShoppingCart) {
			setShowShoppingCart(false);
		}
	}, [showReplacement, showShoppingCart]);

	const cartItems = useSelector((state: RootState) => state.cart.replacements);
	const allItemsSum = getAllItemsCount(cartItems);

	return (
		<div>
			<div className={styles.shoppingCartIconContainer}>
				<IconButton onClick={toggleShoppingCart}>
					<StyledShoppingCartOutlinedIcon size="30px" />
					<div // NOSONAR
						className={styles.shoppingCartIcon}
						onClick={toggleShoppingCart}
						data-testid="shoppingCartItemCount"
					>
						{allItemsSum > 0 && (
							<ShoppingCartItemsLengthIcon
								text={String(allItemsSum)}
								nextRoute={false}
							/>
						)}
					</div>
				</IconButton>
			</div>

			<FlyoutHandler
				showButtons={showButtons}
				dataTestId="replacement-shopping-cart-container"
				showShoppingCartTrigger={showShoppingCart}
			/>
		</div>
	);
};

export default ShoppingCartIcon;
